import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { ShopByCategory as ShopByCategoryComponent } from '@thd-olt-component-react/shop-by-category';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const ShopByCategoryPropTypes = {
  id: string,
};

const ShopByCategoryDefaultProps = {
  id: undefined,
};

export function CustomRenderedShopByCategory({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  function ShopByCategory({ id }) {
    return (
      <QueryProvider key={id} cacheKey={id}>
        <Hydrator
          id="shopByCategory-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <ShopByCategoryComponent componentId={id} />
        </Hydrator>
      </QueryProvider>
    );
  }

  ShopByCategory.propTypes = ShopByCategoryPropTypes;
  ShopByCategory.defaultProps = ShopByCategoryDefaultProps;

  return ShopByCategory;
}
